import { remove, random } from "lodash";

export default function pickRandomOption(form) {
    switch(form.type) {
      case "InputOption": return form;
      case "SumForm":
        var options = form.subforms.map(function(subform, index) {
          return {
            mark: index,
            value: pickRandomOption(subform)
          };
        });
        remove(options, { value : null } );
        return options.length > 0 ? options[random(0, options.length - 1)] : null;
      case "SubjForm":
        var options = form.forms.map(function(subform, index) {
          return {
            mark: index,
            value: pickRandomOption(subform)
          };
        });
        remove(options, { value : null } );
        return options.lenth > 0 ? options[random(0, options.length - 1)] : null;
      case "LockedForm":
      case "EmptyForm":
      case "HTMLElementForm":
        return null;
      case "TimeForm":
      case "MessageForm":
        return pickRandomOption(form.form);
    }
    console.warn(form.type + " is not supported by pickRandomOption");
    return undefined;
  };